export default __webpack_public_path__ + "static/media/Blues.bc6b7866.png";